/**
 * Created by jv on 15/05/2018.
 */
import CONSTANTS from "Sources/games/carrot-game/config/constants"
import Consumable from "./consumable";

export default class Carrot extends Consumable
{
  constructor(scene, x = 0, y = x, position, doubleValue)
  {
    var frame = doubleValue ? "consumables/consumable_carrot-2x-shadow.png" : "consumables/consumable_carrot-shadow.png";
    // 0 is ground
    if(position > 0)
    {
      frame = doubleValue ? "consumables/consumable_carrot-2x.png" : "consumables/consumable_carrot.png";
    }

    super(scene, x, y, CONSTANTS.ATLAS_KEY, frame);

    this.doubleValue = doubleValue === true;
    this.attractTween = null;
  }
}



// WEBPACK FOOTER //
// ./app/js/games/carrot-game/objects/carrot.js